export default __webpack_public_path__ + "static/media/330_business04-nl-web.fa7433eb.png";